export class VenuesComponent {

    private $root:JQuery;

    // @ts-ignore
    constructor(elem:HTMLElement) {
        this.$root = $(elem);
        this.bindUI();
    }

    private bindUI() {
        this.$root
            .find('.js-typeahead')
            .on('typeahead:select', this.handleVenueSelected)
    }

    private handleVenueSelected = (ev:any, selected:any) => {

        this
            .$root
            .find(':input')
            .attr('disabled', 'disabled')
            .addClass('disabled')
        ;
        $
            .ajax({
                type: 'GET',
                url: '/members/venues/detail?id=' + selected.id
            })
            .done((responseData) => {
                // @ts-ignore
                let response = JSON.parse(responseData);
                this.$root.find(':input')
                    .removeAttr('disabled')
                    .removeClass('disabled')
                ;
                this.$root.find('.js-venue__address-street').val(response.address_street);
                this.$root.find('.js-venue__address-district').val(response.address_district);
                this.$root.find('.js-countries-and-regions').trigger('update', response);
                this.$root.find('.js-venue__postalcode').val(response.postcode);
                this.$root.find('.js-venue__id').val(response.id);
            })
        ;


    }
}